import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import Select from "react-select";
import * as service from '../../../services/service';

function Projects() {
    const [state, setState] = useState({
        project: ''
    });
    const [data, setData] = useState([]);
    const [civilIDCData, setCivilIDCData] = useState([]);
    const [civilCEOData, setCivilCEOData] = useState([]);
    const [civilSEOData, setCivilSEOData] = useState([]);
    const [civilDivisionData, setCivilDivisionData] = useState([]);
    const [civilIDCId, setCivilIDCId] = useState('');
    const [civilCEOId, setCivilCEOId] = useState('');
    const [civilSEOId, setCivilSEOId] = useState('');
    const [civilDivisionId, setCivilDivisionId] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };

    const getCivilIDCs = () => {
        fetch(
            service.CIVILIDC_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.civilIDCId, label: item.civilIDC }));
                setCivilIDCData(data2);
            });
    };

    const getCivilCEOs = (id) => {
        fetch(
            service.GET_CIVILCEO_BY_IDC_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CivilIDCId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.civilCEOId, label: item.civilCEO }));
                setCivilCEOData(data2);
            });
    };

    const getCivilSEOs = (id) => {
        fetch(
            service.GET_CIVILSEO_BY_CEO_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CivilCEOId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.civilSEOId, label: item.civilSEO }));
                setCivilSEOData(data2);
            });
    };

    const getCivilDivisions = (id) => {
        fetch(
            service.GET_CIVIL_DIVISION_BY_SEO_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CivilSEOId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.civilDivisionId, label: item.civilDivision }));
                setCivilDivisionData(data2);
            });
    };

    const getDetails = (divId) => {
        const errs = {};
        fetch(
            service.PROJECT_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CivilDivisionId: divId
                })
            })
            .then(res => res.json())
            .then(result => {
                setData(result);
            })
            .catch(err => {
                if (err) {
                    errs[".invalid"] = err;
                    setErrors(err);
                };
            });
    };

    const getDetailsById = (id) => {
        setLoading(true);
        const errs = {};
        fetch(
            service.GET_PROJECT_BY_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ProjectId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.message.messageType === 'Success') {
                    setState({
                        ...state, project: result.project
                    });

                    const idcData = ({ value: result.civilIDCId, label: result.civilIDC });
                    setCivilIDCId(idcData);
                    getCivilCEOs(idcData.value);
                    const ceData = ({ value: result.civilCEOId, label: result.civilCEO });
                    setCivilCEOId(ceData);
                    getCivilSEOs(ceData.value);
                    const seData = ({ value: result.civilSEOId, label: result.civilSEO });
                    setCivilSEOId(seData);
                    getCivilDivisions(seData.value);
                    const divData = ({ value: result.civilDivisionId, label: result.civilDivision });
                    setCivilDivisionId(divData);
                }
                else {
                    errs[".invalid"] = result.message.message;
                    setErrors(errs);
                }
            });
        setLoading(false);
    };
    const handleEdit = (id) => {
        getDetailsById(id);
        localStorage.setItem("ID", JSON.stringify(id));
    }

    useEffect(() => {
        setLoading(true);
        getCivilIDCs();
        setLoading(false);
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!state.project) {
            isValid = false;
            errs[".project"] = "Please enter project name";
        }
        if (!civilDivisionId) {
            isValid = false;
            errs[".civilDivisionId"] = "Please select Civil Division";
        }
        setErrors(errs);
        return isValid;
    }

    const changeHandler = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };

    const CivilIDCChangeHandler = (ev) => {
        setCivilIDCId(ev);
        getCivilCEOs(ev.value);
    }

    const CivilCEOChangeHandler = (ev) => {
        setCivilCEOId(ev);
        getCivilSEOs(ev.value);
    }
    const CivilSEOChangeHandler = (ev) => {
        setCivilSEOId(ev);
        setCivilDivisionData([]);
        getCivilDivisions(ev.value);
    }
    const CivilDivisionChangeHandler = (ev) => {
        setCivilDivisionId(ev);
        getDetails(ev.value);
    }


    const clearHandler = () => {
        localStorage.setItem('ID', null);
        setState({
            ...state, project: ''
        });
        const idc = ({ value: null, label: "Select Civil IDC" });
        setCivilIDCId(idc);
        const ceo = ({ value: null, label: "Select Civil CEO" });
        setCivilCEOId(ceo);
        const seo = ({ value: null, label: "Select Civil SEO" });
        setCivilSEOId(seo);
        const div = ({ value: null, label: "Select Civil Division" });
        setCivilDivisionId(div);

        setData([]);
    }

    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validate()) {
            fetch(
                service.ADD_UPDATE_PROJECT,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        ProjectId: JSON.parse(localStorage.getItem('ID')) !== null ? JSON.parse(localStorage.getItem('ID')) : 0,
                        Project: state.project,
                        CivilIDCId: civilIDCId.value,
                        CivilCEOId: civilCEOId.value,
                        CivilSEOId: civilSEOId.value,
                        CivilDivisionId: civilDivisionId.value,
                        AddedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                        UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        localStorage.setItem('ID', null);
                        // window.location.reload();
                        setState({ ...state, project: '' });
                        getDetails(civilDivisionId.value);
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                    }
                    else {
                        errs[".invalid"] = result.message;
                        setErrors(errs);
                    }
                });
        }
        setLoading(false);
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Project Details
                                </MDTypography>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell width="25%">
                                                <Select
                                                    name="Civil IDC"
                                                    options={civilIDCData} placeholder="Select Civil IDC"
                                                    value={civilIDCId}
                                                    onChange={CivilIDCChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".civilIDCId"]}</div>
                                            </TableCell>
                                            <TableCell width="25%">
                                                <Select
                                                    name="Civil CEO"
                                                    options={civilCEOData} placeholder="Select Civil CEO"
                                                    value={civilCEOId}
                                                    onChange={CivilCEOChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".civilCEOId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell width="25%">
                                                <Select
                                                    name="Civil SEO"
                                                    options={civilSEOData} placeholder="Select Civil SEO"
                                                    value={civilSEOId}
                                                    onChange={CivilSEOChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".civilSEOId"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <Select
                                                    name="Civil Division"
                                                    options={civilDivisionData} placeholder="Select Civil Division"
                                                    value={civilDivisionId}
                                                    onChange={CivilDivisionChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".civilDivisionId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <MDInput label="Project" fullWidth value={state.project || ''}
                                                    name="project"
                                                    onChange={changeHandler}
                                                    id="project"
                                                    required />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".project"]}</div>
                                            </TableCell>                                           
                                        </TableRow>
                                    </TableBody>
                                </Table>
                                <MDBox mt={4} mb={1} textAlign="center">
                                    {loading ? <Oval
                                        heigth="20"
                                        width="20"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                        <div>
                                            <MDButton color="info" onClick={submitHandler}>
                                                SAVE
                                            </MDButton>&nbsp;&nbsp;&nbsp;&nbsp;
                                            <MDButton color="info" onClick={clearHandler}>
                                                CLEAR
                                            </MDButton>
                                        </div>
                                    }
                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                </MDBox>

                            </Card>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">

                                            <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                <TableCell style={{ fontWeight: 'bold' }}>Project</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Civil IDC</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Civil CEO</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Civil SEO</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Civil Division</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                                            </TableRow>

                                            <TableBody>
                                                {data.map((row) => (
                                                    <TableRow
                                                        key={row.projectId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell>{row.project}</TableCell>                                                        
                                                        <TableCell>{row.civilIDC}</TableCell>
                                                        <TableCell>{row.civilCEO}</TableCell>
                                                        <TableCell>{row.civilSEO}</TableCell>
                                                        <TableCell>{row.civilDivision}</TableCell>                                                        
                                                        <TableCell><MDButton onClick={() => handleEdit(row.projectId)}>Edit</MDButton></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                }
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default Projects;